import { cn } from '@/helpers/cn';
import { useRef, useState } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function useEnterView(threshold = 0.1) {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
    useIntersectionObserver(ref, {
        threshold,
    }, (entry, disconnect) => {
        if (entry.isIntersecting) {
            setIsVisible(true);
            disconnect();
        }
    });
    return {
        isVisible,
        isHidden: !isVisible,
        ref,
        animations: {
            basicFade: cn('transition-(opacity,transform) duration-1500 ease-in-out', !isVisible && 'translate-y-2 opacity-0'),
        },
    };
}
